import styled from 'styled-components'

export const LinksTabWrapper = styled.div`
  padding: ${({ theme }) => theme.spacings[6]};

  & > button {
    margin: 0 auto;
  }
`

export const IconDisabled = styled.span`
  color: ${({ theme }) => theme.colors.pinkishGrey};
  width: ${({ theme }) => theme.fontSizes.md};
  cursor: not-allowed;
`
